const articlesBg = function () {
  if (document.getElementById('artykuly')) {
    if (
      document.querySelector('#artykuly').querySelectorAll('.teaser__article')
        .length > 3
    ) {
      document.querySelector('#artykuly').classList.remove('bg--deep');
    } else {
      document.querySelector('#artykuly').classList.add('bg--deep');
    }
  }
};

articlesBg();
